import Vue from "vue";
import VueMeta, { VueMetaOptions } from "vue-meta";

export default () => {
  const options: Partial<VueMetaOptions> = {
    refreshOnceOnNavigation: true,
  };
  Vue.use(VueMeta, options);
};
